import ComboCombolist from "./combolist";

window.o_combo_combolist = window.o_combo_combolist || [];

export function initCinema() {
	const containers = document.querySelectorAll(".combo_combolist-container");
	Array.from(containers).forEach(container => {
		if (container.getAttribute("data-tracked") !== "true") {
			container.setAttribute("data-tracked", "true");
			const combolist = new ComboCombolist(container);
			combolist.initCinemaEvents();
			combolist.addClickEventListenersForComboMoodImage();
			combolist.addClickEventListenersForArticles();
			combolist.addNavigateComboMessageListener();
			window.o_combo_combolist.push(combolist);
		}
	});
}
